import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { createPortal } from 'react-dom';
import { useDevTools } from '../AppContext';

import styles from './DevToolsFloatingButton.module.css';

export const isDevToolsEnvironment =
  !['production', 'staging'].includes(process.env.NODE_ENV) &&
  process.env.REACT_APP_RUNTIME_ENVIRONMENT !== 'production';

function DevToolsFloatingButton() {
  const devToolsSettings = useDevTools();
  const location = useLocation();
  const [portalTarget, setPortalTarget] = React.useState(null);

  React.useEffect(() => {
    if (typeof document !== 'undefined') {
      setPortalTarget(document.body);
    }
  }, []);

  const isVisible = isDevToolsEnvironment && Boolean(devToolsSettings?.devMode);

  if (!isVisible || !portalTarget || location.pathname === '/dev-tools') {
    return null;
  }

  return createPortal(
    <Link className={styles.floatingButton} to="/dev-tools" aria-label="Open developer tools">
      <span className={styles.icon} aria-hidden="true">
        {'</>'}
      </span>
    </Link>,
    portalTarget
  );
}

export default DevToolsFloatingButton;

